import { useEffect } from 'react';

/**
 * Hook để tắt hoàn toàn tính năng zoom bằng cử chỉ 2 ngón tay (pinch-to-zoom)
 * Áp dụng cho toàn bộ ứng dụng kiosk
 */
export const useDisablePinchZoom = () => {
    useEffect(() => {
        // Ngăn chặn context menu (right click)
        const preventContextMenu = (e: Event) => {
            e.preventDefault();
        };

        // Ngăn chặn zoom bằng cử chỉ 2 ngón tay
        const preventZoom = (e: TouchEvent) => {
            // Nếu có nhiều hơn 1 ngón tay, ngăn chặn hành vi mặc định
            if (e.touches.length > 1) {
                e.preventDefault();
            }
        };

        // Ngăn chặn zoom bằng wheel event với Ctrl key (Windows/Linux) hoặc Cmd key (Mac)
        const preventWheelZoom = (e: WheelEvent) => {
            if (e.ctrlKey || e.metaKey) {
                e.preventDefault();
            }
        };

        // Ngăn chặn zoom bằng keyboard shortcuts
        const preventKeyboardZoom = (e: KeyboardEvent) => {
            // Ctrl + Plus, Ctrl + Minus, Ctrl + 0
            if ((e.ctrlKey || e.metaKey) && 
                (e.key === '+' || e.key === '-' || e.key === '=' || e.key === '0')) {
                e.preventDefault();
            }
        };

        // Thêm event listeners với cùng function reference
        document.addEventListener('contextmenu', preventContextMenu);
        document.addEventListener('touchstart', preventZoom, { passive: false });
        document.addEventListener('touchmove', preventZoom, { passive: false });
        document.addEventListener('wheel', preventWheelZoom, { passive: false });
        document.addEventListener('keydown', preventKeyboardZoom);

        // Cleanup function - phải dùng cùng function reference
        return () => {
            document.removeEventListener('contextmenu', preventContextMenu);
            document.removeEventListener('touchstart', preventZoom);
            document.removeEventListener('touchmove', preventZoom);
            document.removeEventListener('wheel', preventWheelZoom);
            document.removeEventListener('keydown', preventKeyboardZoom);
        };
    }, []);
};
